export default "__VITE_ASSET__DDnIhUxS__"